var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateRandomDailyData } from '@web/lib/demo/utils';
import { InitiatedCommunicationByChannel, ReceivedCommunicationByChannel } from '@workalizer/shared/enums';
import { diffComparisonType } from '@workalizer/shared/types';
import { getPercentageDiff } from '@workalizer/shared/utils';
export var communicationByChannel = function (input) {
    var mockDailyData = generateRandomDailyData(input.dateFrom, input.dateTo);
    var withInitiatedDiffs = function (item) { return (__assign(__assign({}, item), { daily: mockDailyData, userPrevPeriodDiff: getPercentageDiff(item.prevTotal, item.total), avgPrevPeriodDiff: __assign(__assign({}, getPercentageDiff(item.prevAvg, item.avg)), { comparisonType: diffComparisonType.previousPeriod }) })); };
    var withReceivedDiffs = function (item) { return (__assign(__assign({}, item), { daily: mockDailyData, userPrevPeriodDiff: getPercentageDiff(item.prevTotal, item.count), avgPrevPeriodDiff: __assign(__assign({}, getPercentageDiff(item.prevAvg, item.avg)), { comparisonType: diffComparisonType.previousPeriod }) })); };
    return {
        Initiated: [
            withInitiatedDiffs({
                channel: InitiatedCommunicationByChannel.EMAILS_SENT,
                total: 45,
                prevTotal: 38,
                avg: 12,
                prevAvg: 10
            }),
            withInitiatedDiffs({
                channel: InitiatedCommunicationByChannel.CHATS_MESSAGES_POSTED,
                total: 128,
                prevTotal: 115,
                avg: 32,
                prevAvg: 28
            }),
            withInitiatedDiffs({
                channel: InitiatedCommunicationByChannel.CHATS_MESSAGES_REACTIONS,
                total: 67,
                prevTotal: 72,
                avg: 17,
                prevAvg: 19
            }),
            withInitiatedDiffs({
                channel: InitiatedCommunicationByChannel.DOCS_COMMENTS_ADDED,
                total: 23,
                prevTotal: 19,
                avg: 6,
                prevAvg: 5
            }),
            withInitiatedDiffs({
                channel: InitiatedCommunicationByChannel.MEETINGS_ORGANIZED,
                total: 8,
                prevTotal: 6,
                avg: 2,
                prevAvg: 2
            })
        ],
        Received: [
            withReceivedDiffs({
                channel: ReceivedCommunicationByChannel.EMAILS_RECEIVED,
                count: 89,
                prevTotal: 76,
                avg: 22,
                prevAvg: 20
            }),
            withReceivedDiffs({
                channel: ReceivedCommunicationByChannel.CHATS_MESSAGES_RECEIVED,
                count: 156,
                prevTotal: 142,
                avg: 39,
                prevAvg: 36
            }),
            withReceivedDiffs({
                channel: ReceivedCommunicationByChannel.CHATS_REACTIONS_RECEIVED,
                count: 58,
                prevTotal: 63,
                avg: 14,
                prevAvg: 16
            }),
            withReceivedDiffs({
                channel: ReceivedCommunicationByChannel.DOCS_COMMENTS_RECEIVED,
                count: 34,
                prevTotal: 41,
                avg: 9,
                prevAvg: 11
            }),
            withReceivedDiffs({
                channel: ReceivedCommunicationByChannel.MEETINGS_PARTICIPATED,
                count: 15,
                prevTotal: 12,
                avg: 4,
                prevAvg: 3
            })
        ]
    };
};
